module.exports = __webpack_public_path__ + "img/icon_waiting.1f036398.png";